const getInitials = (name = '') => {
  if (!name.trim()) return '?';
  return name
    .trim()
    .split(/\s+/)
    .slice(0, 2)
    .map((v) => v[0].toUpperCase())
    .join('');
};

export default getInitials;
